import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import AuthShell from '../../components/auth/AuthShell';
import { Loader2, Check, AlertCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState('verifying'); // verifying|success|error
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (!token) { setState('error'); setErrorMsg('Missing verification token.'); return; }
    axios.post(`${API}/api/auth/verify-email`, { token })
      .then(() => setState('success'))
      .catch(err => {
        setErrorMsg(err.response?.data?.detail || 'Could not verify email.');
        setState('error');
      });
    // `API` is a module-level constant and `axios`/`setState` are stable refs —
    // re-running the effect should be driven by `token` only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <AuthShell title="Verify email" testId="verify-email-page"
      footer={<Link to="/login" className="text-[#00D4FF] hover:underline">Back to sign in</Link>}>
      {state === 'verifying' && (
        <div className="text-center py-6" data-testid="verify-verifying">
          <Loader2 className="h-8 w-8 animate-spin text-[#00D4FF] mx-auto mb-3" />
          <p className="text-sm text-gray-400">Verifying your email…</p>
        </div>
      )}
      {state === 'success' && (
        <div className="text-center py-6" data-testid="verify-success">
          <div className="w-14 h-14 rounded-full bg-[#00D4FF]/15 flex items-center justify-center mx-auto mb-4">
            <Check className="h-6 w-6 text-[#00D4FF]" />
          </div>
          <p className="text-sm font-semibold">Email verified</p>
          <p className="text-[11px] text-gray-500 mt-1">Your account is now fully activated.</p>
          <Link to="/home" className="inline-block mt-5 px-5 py-2 rounded-lg bg-[#FF4D94] text-white text-xs font-bold hover:brightness-110">Go to dashboard</Link>
        </div>
      )}
      {state === 'error' && (
        <div className="text-center py-6" data-testid="verify-error">
          <div className="w-14 h-14 rounded-full bg-red-500/15 flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="h-6 w-6 text-red-400" />
          </div>
          <p className="text-sm font-semibold">Verification failed</p>
          <p className="text-[11px] text-gray-500 mt-1">{errorMsg}</p>
        </div>
      )}
    </AuthShell>
  );
}
